//Third-party packages
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startDownloadingPDFBudget } from '../../redux/actions/sales';

//Custom imports
import { uiManageModalNotification } from '../../redux/actions/ui';
import { Content } from './Content';

/**
 * 
    Author: QBK
    Date: 10-01-2021
 */
export const ConfirmDownload = () => {
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const { activeEdit } = useSelector(state => state.invoice);
  const handleSuccess = () => {
    dispatch(uiManageModalNotification());
    dispatch(startDownloadingPDFBudget(activeEdit.PkVentas));
  };

  //The HTML is being rendered
  return <Content title={'¿Estás seguro de que quieres descargar el pdf?'} action={handleSuccess} />;
};
